/**
 * Formatiert einen Betrag im deutschen Zahlenformat (Euro)
 * @param {number} amount - Der zu formatierende Betrag
 * @returns {string} - Formatierter Betrag (z.B. "1.500,50 €")
 */
export const formatCurrency = (amount) => {
  if (amount === null || amount === undefined || isNaN(amount)) {
    return '0,00 €';
  }

  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
};

/**
 * Formatiert einen Betrag in Tunesischen Dinar (TND)
 * @param {number} amount - Der zu formatierende Betrag
 * @returns {string} - Formatierter Betrag (z.B. "1.500,000 TND")
 */
export const formatCurrencyTND = (amount) => {
  if (amount === null || amount === undefined || isNaN(amount)) {
    return '0,000 TND';
  }

  // TND verwendet 3 Dezimalstellen
  return new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3
  }).format(amount) + ' TND';
};

/**
 * Formatiert einen Betrag ohne Währungssymbol
 * @param {number} amount - Der zu formatierende Betrag
 * @returns {string} - Formatierter Betrag ohne Symbol (z.B. "1.500,50")
 */
export const formatNumber = (amount) => {
  if (amount === null || amount === undefined || isNaN(amount)) {
    return '0,00';
  }

  return new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
};
